import { useAsyncData, useNuxtApp } from '#imports'

import { useExperiments } from '@backmarket/nuxt-module-experiments/useExperiments'
import { useHttpFetch } from '@backmarket/nuxt-module-http-v2/useHttpFetch'

import { getOptionalEndpointTimeoutOptions } from '~/scopes/product-core/composables/useFetch/utils/getOptionalEndpointTimeoutOptions'
import { useUrlParams } from '~/scopes/product-core/composables/useUrlParams/useUrlParams'

export function useFetchTechnicalSpecifications() {
  const nuxtApp = useNuxtApp()
  const { productId } = useUrlParams()
  const $httpFetch = useHttpFetch()
  const experiments = useExperiments()

  return useAsyncData(
    () => `pp-technical-specifications-${productId}`,
    async () => {
      return $httpFetch(
        '/product-page/products/:productId/technical_specifications',
        {
          pathParams: {
            productId,
          },
          query: {
            apple_watch_band_experiment_enabled:
              experiments['experiment.ppAppleWatchBand'] === 'withoutBand',
          },
          ...getOptionalEndpointTimeoutOptions(),
        },
      )
    },
    {
      lazy: true,
      dedupe: 'defer',
      getCachedData: (key) => nuxtApp.payload.data[key],
    },
  )
}
